import React from 'react';
import './NgPlusUpgrade.css';

interface NgPlusUpgradeProps {
  score: number;
  coins: number;
  scoreMultiplier: number;
  coinMultiplier: number;
  onUpgradeScore: () => void;
  onUpgradeCoin: () => void;
  onRollBack: () => void;
}

const NgPlusUpgrade: React.FC<NgPlusUpgradeProps> = ({
  score,
  coins,
  scoreMultiplier,
  coinMultiplier,
  onUpgradeScore,
  onUpgradeCoin,
  onRollBack,
}) => {
  const getScoreUpgradeCost = (level: number): number => {
    return 100 * Math.pow(10, level);
  };

  const getCoinUpgradeCost = (level: number): number => {
    return 100 * Math.pow(10, level);
  };

  const scoreUpgradeCost = getScoreUpgradeCost(scoreMultiplier);
  const coinUpgradeCost = getCoinUpgradeCost(coinMultiplier);
  const canAffordScore = score >= scoreUpgradeCost;
  const canAffordCoin = coins >= coinUpgradeCost;

  return (
    <div className="ng-plus-upgrade-container">
      <h2 className="ng-plus-upgrade-title">New Game Plus</h2>
      <p className="ng-plus-upgrade-subtitle">Upgrade your multipliers before rolling back!</p>
      
      <div className="ng-plus-upgrade-stats">
        <div className="ng-plus-stat">
          <span className="ng-plus-stat-label">Your Score:</span>
          <span className="ng-plus-stat-value">{score}</span>
        </div>
        <div className="ng-plus-stat">
          <span className="ng-plus-stat-label">Your Coins:</span>
          <span className="ng-plus-stat-value">{coins} 🪙</span>
        </div>
      </div>

      <div className="ng-plus-upgrades">
        <div className="ng-plus-upgrade-item">
          <div className="ng-plus-upgrade-header">
            <span className="ng-plus-upgrade-icon">📈</span>
            <div className="ng-plus-upgrade-info">
              <h3>Score Multiplier</h3>
              <p className="ng-plus-upgrade-description">
                Current: {scoreMultiplier}x • Next: {scoreMultiplier + 1}x
              </p>
            </div>
          </div>
          <button
            className={`ng-plus-upgrade-button ${canAffordScore ? 'affordable' : 'unaffordable'}`}
            onClick={onUpgradeScore}
            disabled={!canAffordScore}
          >
            Upgrade ({scoreUpgradeCost} score)
          </button>
        </div>

        <div className="ng-plus-upgrade-item">
          <div className="ng-plus-upgrade-header">
            <span className="ng-plus-upgrade-icon">💰</span>
            <div className="ng-plus-upgrade-info">
              <h3>Coin Multiplier</h3>
              <p className="ng-plus-upgrade-description">
                Current: {coinMultiplier}x • Next: {coinMultiplier + 1}x
              </p>
            </div>
          </div>
          <button
            className={`ng-plus-upgrade-button ${canAffordCoin ? 'affordable' : 'unaffordable'}`}
            onClick={onUpgradeCoin}
            disabled={!canAffordCoin}
          >
            Upgrade ({coinUpgradeCost} 🪙)
          </button>
        </div>
      </div>

      <button className="ng-plus-roll-back-button" onClick={onRollBack}>
        Roll Back
      </button>
    </div>
  );
};

export default NgPlusUpgrade;

